/**
 * Created by Xuz on 2020/02/10.
 * xuz@live.cn
 *
 * 检测流程配置是否合法，包括SVG图上的内容是否合法，数据的最终定义是否合法
 */
import * as WFC from './WFConstants'

class WFValidator {
  constructor (workflow) {
    this.workflow = workflow
    this.aErrorList = []
    this.aLifeNodes = [] // 起点的可连接点集合
    this.aEndLifeNodes = [] // 终点的可连接点集合
    this.aTranLifeNodes = [] // 转换点可连接至的点集合
    this.aPaperNodes = [] // 纸质送件集合
  }

  check () {
    let wfStartNode = this.workflow.getStartNode()
    if (wfStartNode == null) {
      this.aErrorList.push('流程没有起点')
      return
    }

    // 从起点连接出去的路径只能是电子送件
    let startLinkers = this.workflow.getNodeRoads(wfStartNode.uuid())
    if (startLinkers != null) {
      for (let i = 0; i < startLinkers.length; i++) {
        if (startLinkers[i] == null) {
          continue
        }
        // 找出LINKER中起点是自己的
        if (startLinkers[i].getRouteType() !== 'F') {
          this.aErrorList.push('连接至起点的路径类别只能是电子送件')
        }
      }
    }

    let wfEndNodes = this.workflow.getEndNodes()
    if (wfEndNodes.length === 0) {
      this.aErrorList.push('流程没有终点')
      return
    }

    let activities = this.workflow.getActivities()
    let transNodes = this.workflow.getTransNodes()

    // 先建立活点地图(包括起点与终点)
    this.aLifeNodes = []
    this.aEndLifeNodes = []
    this.aTranLifeNodes = []
    this.aPaperNodes = []
    this.aPaperNodes = this.workflow.getPaperNodes()

    // 检查纸质送件是否满足不能外发的条件
    for (let i in this.aPaperNodes) {
      let pNode = this.aPaperNodes[i]
      let selLinkers = this.workflow.getNodeRoads(i)
      if (selLinkers != null) {
        for (let j = 0, len = selLinkers.length; j < len; j++) {
          if (selLinkers[j] == null) { // 连线已经删除
            continue
          }
          // 找出LINKER中起点是自己的
          if (selLinkers[j].getStart() === pNode.uuid()) {
            this.aErrorList.push('[' + pNode.getName() + ']为纸质送件，该节点不允许向外连接')
            break
          }
          // 连接到纸质送件的路径类型只能是送件
          if (selLinkers[j].getEnd() === pNode.uuid()) {
            let lt = selLinkers[j].getRouteType()
            if (lt !== 'F') {
              this.aErrorList.push('[' + selLinkers[j].getName() + ']因连接至纸质送件，其路径类型只能为送件')
              break
            }
          }
        }
      }
    }

    this.analyseStart(this.workflow.getStartNode())

    // 分析结点集合
    for (let i = 0; i < wfEndNodes.length; i++) {
      this.analyseEnd(wfEndNodes[i])
    }

    // 分析转换点集合
    for (let i = 0; i < transNodes.length; i++) {
      this.analyseTrans(transNodes[i])
    }

    // 分析传阅或会签节点与外部节点连接的合法性，传阅与会签不能走到起点与终点
    for (let i in activities) {
      let activity = activities[i]
      let ft = activity.getFlowType()
      // 传阅，会签(等待与非等待)
      if (ft === 'H' || ft === 'Y' || ft === 'I' || ft === 'C' || ft === 'D') {
        // 检查他们可到达的节点
        let canReachNodes = this.getInnerBranchCanReach(activity)
        for (let j in canReachNodes) {
          let canReachNode = canReachNodes[j]
          if (canReachNode.getType() === WFC.NODE_TYPE_START_NODE || canReachNode.getType() === WFC.NODE_TYPE_END_NODE) {
            this.aErrorList.push('[' + activity.getName() + ']不能有任何路径到达起点或终点')
          }
        }
      }
    }

    // 分析传阅或会签节点与外部节点连接的合法性，启动内环的节点必须是送件，而内环中连接至该节点必须不是电子送件
    for (let i in activities) {
      let activity = activities[i]
      let ft = activity.getFlowType()
      if (ft === 'H' || ft === 'Y' || ft === 'I' || ft === 'C' || ft === 'D') { // 传阅，会签(等待与非等待)
        // 检查他们可到达的节点
        let innerNodes = this.getInnerBranchCanReachWithTrans(activity)
        // 获得所有终点是该节点的节点
        let startLinkers = this.workflow.getNodeRoads(activity.uuid())
        let l = null
        if (startLinkers != null) {
          for (let j = 0, len = startLinkers.length; j < len; j++) {
            l = startLinkers[j]
            if (l == null) { // 连线已经删除
              continue
            }
            // 找出LINKER中终点是自己的
            if (l.getEnd() === activity.uuid()) {
              let linkStartNode = this.workflow.getElement(l.getStart())
              let rt = l.getRouteType()
              if (innerNodes[linkStartNode.uuid()] != null) { // 属于内环当中的节点
                if (rt !== 'B' && rt !== 'X' && rt !== 'Y') { // 内环中只允许是退件与返回至路径中的人
                  this.aErrorList.push('[' + l.getName() + ']的路径类别设置错误，只能是退件给送件人或反馈至路径')
                }
              } else {
                if (rt !== 'F') {
                  this.aErrorList.push('[' + l.getName() + ']的路径类别设置错误，从内环外部连接时路径类别必须为送件')
                }
              }
            }
          }
        }
      }
    }

    // 分析传阅或会签节点内，如果再次出现可分支的属于问题流程
    let errTranNodes = []
    let errTranNodesX = []
    for (let i in activities) {
      let activity = activities[i]
      let ft = activity.getFlowType()
      if (ft === 'H' || ft === 'Y' || ft === 'I' || ft === 'C' || ft === 'D') { // 传阅，会签(等待与非等待)
        // 检查他们可到达的节点
        let innerNodes = this.getInnerBranchCanReachWithTrans(activity)
        for (let j in innerNodes) {
          let inNode = innerNodes[j]
          let ft = inNode.getFlowType()
          if (inNode.uuid() !== activity.uuid()) {
            if (ft === 'H' || ft === 'Y' || ft === 'I' || ft === 'C' || ft === 'D') { // 传阅，会签(等待与非等待)
              let tranNodes = this.findNodeCanGoToTrans(inNode)
              for (let k in tranNodes) {
                let tn = tranNodes[k]
                if (tn.getSpecialType() !== 'Y') { // 是通过环出去的可忽略
                  let canToNodes = this.findNodeCanGoToNodes(tn)
                  for (let z in canToNodes) {
                    let w = canToNodes[z]
                    let wt = w.getType()
                    if (wt === WFC.NODE_TYPE_START_NODE || wt === WFC.NODE_TYPE_END_NODE) {
                      errTranNodes[inNode.uuid()] = inNode
                    }
                  }
                } else { // 检查是否有设置了分流结束的状态点没有分流起点
                  let canToNodes = this.findNodeBackGoToNodes(tn)
                  let bHasX = false
                  for (let z in canToNodes) {
                    let w = canToNodes[z]
                    if (w.getSpecialType() === 'X') {
                      bHasX = true
                    }
                  }
                  if (!bHasX) {
                    errTranNodesX[tn.uuid()] = tn
                  }
                }
              }
            }
          }
        }
      }
    }
    for (let i in errTranNodes) {
      this.aErrorList.push('[' + errTranNodes[i].getName() + ']不合法，其属于内环当中的复数节点，其不能有到达终点的路径存在')
    }
    for (let i in errTranNodesX) {
      this.aErrorList.push('[' + errTranNodesX[i].getName() + ']不合法，其属于分流结束节点但并不存在可到达其的分流开始')
    }

    // 先计算出所有属于环内的节点
    let allSubNodes = []
    for (let j = 0; j < transNodes.length; j++) {
      let tranSubs = this.findTransInnerNodes(transNodes[j])
      for (let i in tranSubs) {
        allSubNodes[i] = tranSubs[i]
      }
    }

    // 从一个环出来的节点不能是另一个环当中的节点
    for (let j = 0; j < transNodes.length; j++) {
      let trans = transNodes[j]
      let selLinkers = this.workflow.getNodeRoads(trans.uuid())
      if (selLinkers == null) {
        continue
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getStart() === trans.uuid()) {
          let outNode = this.workflow.getElement(selLinkers[i].getEnd())
          if (allSubNodes[outNode.uuid()] != null) {
            this.aErrorList.push('[' + selLinkers[i].getName() + ']不合法，其所连接至的节点不能属于另一环当中的节点')
          }
        }
      }
    }

    // 必须可以有路径连接至状态点
    for (let i in activities) {
      let activity = activities[i]
      let ft = activity.getFlowType()
      if (ft === 'H' || ft === 'Y' || ft === 'C') { // 传阅，会签(等待与非等待)
        let trans = this.findNodeCanGoToTransWithBreak(activity)
        let z = 0
        for (let j in trans) {
          z++
        }
        if (z === 0) {
          this.aErrorList.push('[' + activity.getName() + ']不合法，无法到达任何状态点')
        }
      }
    }

    // 检查是否死点
    for (let i in activities) {
      let activity = activities[i]
      if (activity != null) {
        if (this.isDeadRoad(activity)) {
          this.aErrorList.push('[' + activity.getName() + ']是无效节点，从起点不能连接至该点')
        }
        if (this.isEndDeadRoad(activity)) {
          this.aErrorList.push('[' + activity.getName() + ']是无效节点，该点不能连接至终点')
        }
      }
    }

    /*
     * 检查xml文件的合法性
     * 很多时候用户可能只操作了SVG图上的图形，但往往忘记填写每个节点的详细资料
     * 而这时通过严格的检测最终的xml文档检测缺少的内容，再提醒使用者填写相关的资料
     */
    let docRoot = this.workflow.getWfXml().getRootElement()
    let nodeDefine = docRoot.getElementsByTagName('define')[0]
    if (this.getFormAttribute(nodeDefine, 'class') == null) { // 没有类型定义就表示总定义未完成
      this.aErrorList.push('整个流程的属性还没设置，请双击[' + nodeDefine.getAttribute('name') + ']进行设置')
      return
    }

    // 每个普通节点是否都已经选择了人员
    let nodeActivitys = this.getCommentNodeList(docRoot)
    for (let i = 0; i < nodeActivitys.length; i++) {
      if (this.getFormAttribute(nodeActivitys[i], 'fcChooseUser') == null) {
        this.aErrorList.push(nodeActivitys[i].getAttribute('name') + '还未进行详细设置')
      }
    }

    // TODO 每个自循环路径上的提示语一定要填

    // var nodeRoutes = docRoot.selectNodes('routes/route')
    // for (var i = 0; i < nodeRoutes.length; i++) {
    //   var tips = this.getFormAttribute(nodeRoutes[i], 'fsTips')
    //   if (tips == null || __isEmpty(tips)) {
    //     $errorList.add(new ErrorModel(nodeRoutes[i].getAttribute('name') + '还未进行详细设置'))
    //   }
    // }

    // 如果已经有错误先终止
    if (this.aErrorList.length > 0) {
      return
    }

    // TODO 自循环节点只能是送件

    // 分析所有会签(等待模式)的节点的状态点是否没有从状态点连接出去
    // 分析所有会签(非等待模式)的节点的状态点是否已经最少设定了一个外接的连接
    for (let i = 0; i < transNodes.length; i++) {
      this.analyseTransHuiQian(transNodes[i])
    }

    // 状态点本身的全法性检查
    this.analyseTransLocal(transNodes)

    // 所有连接至终点的节点是否都必须是废弃、办结、归档
    for (let i = 0; i < wfEndNodes.length; i++) {
      let endNodeId = wfEndNodes[i].uuid()
      let endRoutes = this.getEndRouteList(docRoot, endNodeId, true)
      for (let j = 0; j < endRoutes.length; j++) {
        let ft = this.getFormAttribute(endRoutes[j], 'flowType')
        if (ft !== 'T' && ft !== 'C' && ft !== 'D') {
          this.aErrorList.push(endRoutes[j].getAttribute('name') + '的路径类别必须为[废弃、归档、办结]之一')
        }
      }
    }

    // 所有连接至转换点的只能是送件
    for (let i = 0; i < transNodes.length; i++) {
      let tranNodeId = transNodes[i].uuid()
      // 所有指向该节点的路径
      let endRoutes = this.getEndRouteList(docRoot, tranNodeId, true)
      for (let j = 0; j < endRoutes.length; j++) {
        let ft = this.getFormAttribute(endRoutes[j], 'flowType')
        if (ft !== 'F') {
          this.aErrorList.push(endRoutes[j].getAttribute('name') + '的路径类别因为其连接到状态点所以必须为送件类型')
        }
      }
    }

    // 所有不是连接至终点的路径都不能是废弃、办结、归档之一
    for (let i = 0; i < wfEndNodes.length; i++) {
      let endNodeId = wfEndNodes[i].uuid()
      let endRoutes = this.getEndRouteList(docRoot, endNodeId, false)
      for (let j = 0; j < endRoutes.length; j++) {
        let ft = this.getFormAttribute(endRoutes[j], 'flowType')
        if (ft === 'T' && ft === 'C' && ft === 'D') {
          this.aErrorList.push(endRoutes[j].getAttribute('name') + '的路径类别不能为[废弃、归档、办结]之一')
        }
      }
    }
  }

  getCheckResult () {
    return this.aErrorList.length === 0
  }

  getErrorList () {
    return this.aErrorList
  }

  getFormAttribute (node, name) {
    let atts = node.getElementsByTagName('form-attribute')
    for (let i = 0; i < atts.length; i++) {
      let item = atts[i]
      if (item.getAttribute('name') === name) {
        return item.textContent
      }
    }

    return null
  }

  getCommentNodeList (doc) {
    let tmp = []
    let activities = doc.getElementsByTagName('activitys')[0].getElementsByTagName('activity')
    for (let i = 0; i < activities.length; i++) {
      let item = activities[i]
      if (item.getAttribute('type') === WFC.NODE_TYPE_COMMON_NODE) {
        tmp.push(item)
      }
    }

    return tmp
  }

  getEndRouteList (doc, endNodeId, isEqualEndNode) {
    let tmp = []
    let routes = doc.getElementsByTagName('routes')[0].getElementsByTagName('route')
    for (let i = 0; i < routes.length; i++) {
      let item = routes[i]
      if (item.getAttribute('end') === endNodeId) {
        tmp.push(item)
      }
    }

    return tmp
  }

  /**
   * 分析整张图，建立可通的节点图
   * 找一个节点可以到的所有节点的集合
   */
  analyseStart (elNode) {
    this.aLifeNodes[elNode.uuid()] = elNode
    let selLinkers = this.workflow.getNodeRoads(elNode.uuid())
    if (selLinkers != null) {
      let len = selLinkers.length
      for (let i = 0; i < len; i++) {
        if (selLinkers[i] == null) {
          continue
        }
        // 找出LINKER中起点是自己的
        if (selLinkers[i].getStart() === elNode.uuid()) {
          let endNode = this.workflow.getElement(selLinkers[i].getEnd())
          // 如果已经找过该点的路就不找了
          if (this.aLifeNodes[endNode.uuid()] != null) {
            continue
          }
          this.analyseStart(endNode)
        }
      }
    }
  }

  /**
   * 分析整张图，建立可通的节点图结束点的集合
   * 找一个节点可以到的所有节点的集合
   */
  analyseEnd (elNode) {
    this.aEndLifeNodes[elNode.uuid()] = elNode
    let selLinkers = this.workflow.getNodeRoads(elNode.uuid())
    if (selLinkers != null) {
      let len = selLinkers.length
      for (let i = 0; i < len; i++) {
        if (selLinkers[i] == null) {
          continue
        }
        // 找出LINKER中结束点是自己的
        if (selLinkers[i].getEnd() === elNode.uuid()) {
          let startNode = this.workflow.getElement(selLinkers[i].getStart())
          // 如果已经找过该点的路就不找了
          if (this.aEndLifeNodes[startNode.uuid()] != null) {
            continue
          }
          this.analyseEnd(startNode)
        }
      }
    }
  }

  isDeadRoad (elNode) {
    if (this.aLifeNodes[elNode.uuid()] != null) {
      return false
    }
    return true
  }

  /**
   * 检查是否非法路径，如果一个节点不能到达任何一个终点就为非法
   */
  isEndDeadRoad (elNode) {
    // TODO 如果是子流其本身可以不连接到结点

    if (this.aEndLifeNodes[elNode.uuid()] != null) {
      return false
    }

    // TODO 如果没连接至终点，但连接至子流也算合法

    // 连接至转换点也是合法
    if (this.aTranLifeNodes[elNode.uuid()] != null) {
      return false
    }

    // 如果其本身是纸质送件节点也是合法的
    if (this.aPaperNodes[elNode.uuid()] != null) {
      return false
    }

    return true
  }

  /**
   * 检查会签送件的合法性
   */
  analyseTransHuiQian (elNode) {
    const that = this
    let canGoRoutes = []
    let nodeHuiQian = null
    transCheck(elNode)

    if (nodeHuiQian == null) {
      this.aErrorList.push('没有任何传阅或会签或并发的节点可连接至[' + elNode.getName() + ']')
      return
    }

    // 可以到达的节点不能有起点或终点
    for (let i in canGoRoutes) {
      let node = canGoRoutes[i]
      if (node.getType() === WFC.NODE_TYPE_START_NODE || node.getType() === WFC.NODE_TYPE_END_NODE) {
        this.aErrorList.push('[' + elNode.getName() + ']不能有任何不经过会签或传阅或并发的路径而连接至起点或终点')
      }
    }

    let huiQianType = nodeHuiQian.getFlowType()
    // 这是等待的会签，其状态点不能有外连接
    if (huiQianType === 'H' || huiQianType === 'C') {
      let outs = this.workflow.getNodeRoadsOut(elNode.uuid())
      if (outs.length > 0) {
        let nodeN = huiQianType === 'H' ? '会签' : '并发'
        // 如果该状态点是属于另外的一个非等待节点的允许
        let startLinkNodes = this.getHuiQianNodesCanGoTrans(elNode)
        let bFine = false
        for (let k = 0; k < startLinkNodes.length; k++) {
          let t = startLinkNodes[k].getFlowType()
          if (t === 'I' || t === 'D') {
            bFine = true
            break
          }
        }
        if (!bFine) {
          this.aErrorList.push(nodeN + '节点[' + nodeHuiQian.getName() + ']为等待模式，其所能达到的状态点不能有外连接')
        }
      }
    } else if (huiQianType === 'I' || huiQianType === 'D') { // 非等待的会签，状态点必须有外连接
      let outs = this.workflow.getNodeRoadsOut(elNode.uuid())
      if (outs.length === 0) {
        let nodeN = huiQianType === 'I' ? '会签' : '并发'
        this.aErrorList.push(nodeN + '节点[' + nodeHuiQian.getName() + ']为非等待模式，其所能达到的状态点必须有外连接')
      } else {
        // 外连接只能连接至指定的节点
        let canReachNodes = getTransCanOutNodes(elNode)
        // 外连接的路径必须只是送件，退件给路径办理人
        for (let i = 0; i < outs.length; i++) {
          let t = outs[i].getRouteType()
          if (t !== 'F' && t !== 'X' && t !== 'Y') {
            this.aErrorList.push('从状态点[' + elNode.getName() + ']连接出去的路径只能是送件、退回路径办理人之一')
          }

          // 并且连接出去的节点类型只能是电子送件
          let endN = that.workflow.getElement(outs[i].getEnd())
          if (t === 'F' && endN.getFlowType() !== 'E') {
            this.aErrorList.push('从状态点[' + elNode.getName() + ']连接出去的路径是送件时其目标节点只能是电子送件类型')
          }

          let linkTo = outs[i].getEnd()
          if (canReachNodes[linkTo] == null) {
            this.aErrorList.push('状态点外连接[' + outs[i].getName() + ']连接不正确，请检查：\n1.状态点连接出去的路径节点必须是会签/并发外的一般节点\n2.如果是会签嵌套，那只能是父分支的节点之一\n3.节点的流向类别为电子送件')
          }
        }
      }
    }

    /**
     * 获得某个状态点可以外连接的节点的集合
     */
    function getTransCanOutNodes (node) {
      // 状态点可以外连接的节点需要符合以下的要求，其必须是会签外的节点(如果会签有被签套就返回嵌套前的可用节点)
      let canGos = []
      let canNodes = []
      transInner(node, false)
      canGos = []
      // 寻找可以连接出去的并且可以到终点的
      transOuter(node, false)
      return canNodes

      function transOuter (outNode, record) {
        canGos[outNode.uuid()] = outNode
        let selLinkers = that.workflow.getNodeRoads(outNode.uuid())
        for (let i = 0, len = selLinkers.length; i < len; i++) {
          if (selLinkers[i] == null) { // 连线已经删除
            continue
          }
          // 找出LINKER中结束点是自己的
          if (selLinkers[i].getStart() === outNode.uuid()) {
            let endNode = that.workflow.getElement(selLinkers[i].getEnd())
            // 如果已经找过该点的路就不找了
            if (canGos[endNode.uuid()] != null) {
              continue
            }

            let ft = endNode.getFlowType()
            if (ft === 'H' || ft === 'I' || ft === 'Y' || ft === 'C' || ft === 'D') {
              canNodes[endNode.uuid()] = endNode
              continue
            }
            canNodes[endNode.uuid()] = endNode
          }
        }
      }

      function transInner (inNode, record) {
        canGos[inNode.uuid()] = inNode
        let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
        for (let i = 0, len = selLinkers.length; i < len; i++) {
          if (selLinkers[i] == null) { // 连线已经删除
            continue
          }

          // 找出LINKER中结束点是自己的
          if (selLinkers[i].getEnd() === inNode.uuid()) {
            let startNode = that.workflow.getElement(selLinkers[i].getStart())

            // 如果已经找过该点的路就不找了
            if (canGos[startNode.uuid()] != null) {
              continue
            }

            // 找到了启动的会签节点
            let ft = startNode.getFlowType()
            if (ft === 'H' || ft === 'I' || ft === 'Y' || ft === 'C' || ft === 'D') {
              if (!record) {
                transInner(startNode, true)
              } else {
                break
              }
            } else {
              // 开始属于可到达的节点
              if (record) {
                // 必须是一般电子送件
                if (startNode.getFlowType() === 'E') {
                  canNodes[startNode.uuid()] = startNode
                }
              }
              transInner(startNode, record)
            }
          }
        }
      }
    }

    // 获得一个状态点可以到达的节点
    function transCheck (node) {
      canGoRoutes[node.uuid()] = node
      let selLinkers = that.workflow.getNodeRoads(node.uuid())
      if (selLinkers != null) {
        for (let i = 0, len = selLinkers.length; i < len; i++) {
          if (selLinkers[i] == null) { // 连线已经删除
            continue
          }
          // 找出LINKER中结束点是自己的
          if (selLinkers[i].getEnd() === node.uuid()) {
            let startNode = that.workflow.getElement(selLinkers[i].getStart())
            // 如果已经找过该点的路就不找了
            if (canGoRoutes[startNode.uuid()] != null) {
              continue
            }
            // 找到了启动的会签节点
            let ft = startNode.getFlowType()
            if (ft === 'H' || ft === 'I' || ft === 'Y' || ft === 'C' || ft === 'D') {
              nodeHuiQian = startNode
              continue
            } else {
              transCheck(startNode)
            }
          }
        }
      }
    }
  }

  /**
   * 获得传阅或会签件所可以到达的节点集合
   */
  getInnerBranchCanReachWithTrans (node) {
    const that = this
    let canGos = []
    innerLoop(node)
    return canGos

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getStart() === inNode.uuid()) {
          let endNode = that.workflow.getElement(selLinkers[i].getEnd())
          // 如果已经找过该点的路就不找了
          if (canGos[endNode.uuid()] != null) {
            continue
          }
          // 遇到状态点时断开
          if (endNode.getType() === WFC.NODE_TYPE_TRANS_NODE) {
            canGos[endNode.uuid()] = endNode
            continue
          } else {
            innerLoop(endNode)
          }
        }
      }
    }
  }

  /**
   * 查找状态点所属于的环当中的所有节点
   */
  findTransInnerNodes (tranNode) {
    const that = this
    let canGos = []
    innerLoop(tranNode)
    return canGos

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getEnd() === inNode.uuid()) {
          let startNode = that.workflow.getElement(selLinkers[i].getStart())
          // 如果已经找过该点的路就不找了
          if (canGos[startNode.uuid()] != null) {
            continue
          }
          // 遇到状态点时断开
          let ft = startNode.getFlowType()
          if (ft === 'H' || ft === 'I' || ft === 'Y' || ft === 'C' || ft === 'D') {
            continue
          } else {
            innerLoop(startNode)
          }
        }
      }
    }
  }

  /**
   *查找节点可以到达的状态点
   */
  findNodeCanGoToTrans (node) {
    const that = this
    let canGos = []
    let tranNodes = []
    innerLoop(node)
    return tranNodes

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getStart() === inNode.uuid()) {
          let endNode = that.workflow.getElement(selLinkers[i].getEnd())

          // 如果已经找过该点的路就不找了
          if (canGos[endNode.uuid()] != null) {
            continue
          }

          // 遇到状态点时断开
          if (endNode.getType() === WFC.NODE_TYPE_TRANS_NODE) {
            canGos[endNode.uuid()] = endNode
            tranNodes[endNode.uuid()] = endNode
            continue
          } else {
            innerLoop(endNode)
          }
        }
      }
    }
  }

  /**
   * 查找节点可以到达的状态点，如果中途遇到其它复数节点则中断，只对传阅，会签等待，并发等待中断
   */
  findNodeCanGoToTransWithBreak (node) {
    const that = this
    let canGos = []
    let tranNodes = []
    innerLoop(node)
    return tranNodes

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) {
          // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getStart() === inNode.uuid()) {
          let endNode = that.workflow.getElement(selLinkers[i].getEnd())
          // 如果已经找过该点的路就不找了
          if (canGos[endNode.uuid()] != null) {
            continue
          }
          let ft = endNode.getFlowType()
          if (ft === 'H' || ft === 'Y' || ft === 'C') { // 传阅，会签(等待与非等待)
            continue
          }
          // 遇到状态点时断开
          if (endNode.getType() === WFC.NODE_TYPE_TRANS_NODE) {
            canGos[endNode.uuid()] = endNode
            tranNodes[endNode.uuid()] = endNode
            continue
          } else {
            innerLoop(endNode)
          }
        }
      }
    }
  }

  /**
   * 获得传阅或会签件所可以到达的节点集合
   */
  getInnerBranchCanReach (node) {
    const that = this
    let canGos = []
    innerLoop(node)
    return canGos

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) {
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getStart() === inNode.uuid()) {
          let endNode = that.workflow.getElement(selLinkers[i].getEnd())
          // 如果已经找过该点的路就不找了
          if (canGos[endNode.uuid()] != null) {
            continue
          }
          // 遇到状态点时断开
          if (endNode.getType() === WFC.NODE_TYPE_TRANS_NODE) {
            continue
          } else {
            innerLoop(endNode)
          }
        }
      }
    }
  }

  /**
   * 分析可连接到转换点的节点
   */
  analyseTrans (elNode, bDeep) {
    this.aTranLifeNodes[elNode.uuid()] = elNode
    let selLinkers = this.workflow.getNodeRoads(elNode.uuid())
    if (selLinkers != null) {
      for (let i = 0, len = selLinkers.length; i < len; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER中结束点是自己的
        if (selLinkers[i].getEnd() === elNode.uuid()) {
          let startNode = this.workflow.getElement(selLinkers[i].getStart())
          // 如果已经找过该点的路就不找了
          if (this.aTranLifeNodes[startNode.uuid()] != null) {
            continue
          }
          // 如果节点是属于传阅或者会签就停止分析
          let ft = startNode.getFlowType()
          if (ft === 'Y' || ft === 'H' || ft === 'I' || ft === 'C' || ft === 'D') {
            // _tranNodeFlowType.push(startNode.uuid())
            this.aTranLifeNodes[startNode.uuid()] = startNode
            if (!bDeep) {
              this.analyseTrans(startNode, true)
            }
          } else {
            this.analyseTrans(startNode, false)
          }
        }
      }
    }
  }

  /**
   * 检查状态点是否能反向连接到起点或节点，如果经过了会签传阅就中断
   */
  analyseTransLocal (trans) {
    // 所有节点只能有一个连接至状态点
    let canLinkNodes = []
    let errorNodes = []
    for (let i = 0; i < trans.length; i++) {
      let tran = trans[i]
      let selLinkers = this.workflow.getNodeRoads(tran.uuid())
      for (let j = 0; j < selLinkers.length; j++) {
        if (selLinkers[j] == null) {
          continue
        }
        // 找出LINKER中结束点是自己的
        if (selLinkers[j].getEnd() === tran.uuid()) {
          let startNode = this.workflow.getElement(selLinkers[j].getStart())
          if (canLinkNodes[startNode.uuid()] != null) {
            errorNodes[startNode.uuid()] = startNode
          } else {
            canLinkNodes[startNode.uuid()] = startNode
          }
        }
      }
    }
    for (let i in errorNodes) {
      this.aErrorList.push('[' + errorNodes[i].getName() + ']不能同时连接到多个状态点')
    }
  }

  /**
   * 查找节点可以到达的状态点
   */
  findNodeCanGoToNodes (node) {
    const that = this
    let canGos = []
    innerLoop(node)
    return canGos

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      let selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (let i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getStart() === inNode.uuid()) {
          let endNode = that.workflow.getElement(selLinkers[i].getEnd())
          // 如果已经找过该点的路就不找了
          if (canGos[endNode.uuid()] != null) {
            continue
          }
          if (endNode.getType() === WFC.NODE_TYPE_TRANS_NODE) {
            continue
          } else {
            innerLoop(endNode)
          }
        }
      }
    }
  }

  /**
   * 查找节点可逆向走到的点
   */
  findNodeBackGoToNodes (node) {
    const that = this
    let canGos = []
    innerLoop(node)
    return canGos

    function innerLoop (inNode) {
      canGos[inNode.uuid()] = inNode
      var selLinkers = that.workflow.getNodeRoads(inNode.uuid())
      if (selLinkers == null) {
        return
      }
      for (var i = 0; i < selLinkers.length; i++) {
        if (selLinkers[i] == null) { // 连线已经删除
          continue
        }
        // 找出LINKER的起点
        if (selLinkers[i].getEnd() === inNode.uuid()) {
          let endNode = that.workflow.getElement(selLinkers[i].getStart())
          // 如果已经找过该点的路就不找了
          if (canGos[endNode.uuid()] != null) {
            continue
          }
          if (endNode.getType() === WFC.NODE_TYPE_TRANS_NODE) {
            continue
          } else {
            innerLoop(endNode)
          }
        }
      }
    }
  }

  /**
   * 查找可以到达某个状态点的会签或传阅等节点
   */
  getHuiQianNodesCanGoTrans (trans) {
    // 必须可以有路径连接至状态点
    let canNodes = []
    let activities = this.workflow.getActivities()
    for (let i in activities) {
      let activity = activities[i]
      let ft = activity.getFlowType()
      if (ft === 'H' || ft === 'I' || ft === 'Y' || ft === 'C' || ft === 'D') {
        let transCGT = this.findNodeCanGoToTrans(activity)
        for (let j in transCGT) {
          if (transCGT[j].uuid() === trans.uuid()) {
            canNodes.push(activity)
          }
        }
      }
    }
    return canNodes
  }
}

export default WFValidator
